import React from 'react';

import { CharacterTheme } from '@dndbeyond/character-rules-engine/es';

import BaseSvg from '../../BaseSvg';

interface Props {
    fillColor: string;
    backgroundColor: string;
    className: string;
}
export default class SidebarCapSvg extends React.PureComponent<Props> {
    static defaultProps = {
        className: '',
    };

    render() {
        const { fillColor, backgroundColor, className } = this.props;

        let classNames: Array<string> = ['ddbc-sidebar-cap-svg', className];

        return (
            <BaseSvg className={classNames.join(' ')} viewBox="0 0 340 18">
                <path
                    fill={backgroundColor}
                    d="M328.1,6.19H201a57,57,0,0,1-30.15,9.14A54.55,54.55,0,0,1,141,6.19H12A30.25,30.25,0,0,1,.4,17.26V18H340v-.27A28.68,28.68,0,0,1,328.1,6.19Z"
                />
                <path fill={'none'} stroke={fillColor} strokeMiterlimit={10} strokeWidth={'3px'} d="M-46,22.28" />
                <path fill={'none'} stroke={fillColor} strokeMiterlimit={10} strokeWidth={'1.5px'} d="M168.15,3" />
                <path
                    fill={'none'}
                    stroke={fillColor}
                    strokeMiterlimit={10}
                    strokeWidth={'2px'}
                    d="M339.6,17.09C328.4,12.16,325.17,1,325.17,1H169.42"
                />
                <path
                    fill={'none'}
                    stroke={fillColor}
                    strokeMiterlimit={10}
                    strokeWidth={'2px'}
                    d="M.4,17.09C11.6,12.16,14.83,1,14.83,1H170.41"
                />
                <path fill={'none'} stroke={fillColor} strokeMiterlimit={10} strokeWidth={'1.5px'} d="M171.85,3.56" />
                <path
                    fill={'none'}
                    stroke={fillColor}
                    strokeMiterlimit={10}
                    strokeWidth={'2px'}
                    d="M200.23,6.19c-7.16,6.12-20.56,8.32-30.35,8.32"
                />
                <path
                    fill={'none'}
                    stroke={fillColor}
                    strokeMiterlimit={10}
                    strokeWidth={'2px'}
                    d="M170.12,14.51c-9.79,0-23.19-2.2-30.35-8.32"
                />
                <path fill={fillColor} d="M167.12,14.51a3,3,0,1,0,3-3,3,3,0,0,0-3,3" />
                <path
                    fill={'none'}
                    stroke={fillColor}
                    strokeMiterlimit={10}
                    strokeWidth={'3px'}
                    d="M1.5,18V10.89A5.44,5.44,0,0,1,7,5.5h326.1a5.44,5.44,0,0,1,5.45,5.39V18"
                />
            </BaseSvg>
        );
    }
}
